import AOS from 'aos';

const AOS_ANIMATION_DURATION = 800;

document.addEventListener('aos:in', ({ detail }) => {
    const delay = detail.dataset.aosDelay ? parseInt(detail.dataset.aosDelay) : 0;
    const duration = detail.dataset.aosDuration
        ? parseInt(detail.dataset.aosDurationaosDuration)
        : AOS_ANIMATION_DURATION;

    detail.classList.add('aos-animating');

    setTimeout(() => {
        detail.classList.remove('aos-animating');
    }, duration + delay);
});

export default function() {
    AOS.init({
        easing: 'ease-in-out-back',
        duration: AOS_ANIMATION_DURATION,
        startEvent: 'load',
        once: false,
    });
}
